import { render, staticRenderFns } from "./ModalReference.vue?vue&type=template&id=2dc1d4bb&"
import script from "./ModalReference.vue?vue&type=script&lang=js&"
export * from "./ModalReference.vue?vue&type=script&lang=js&"
import style0 from "./ModalReference.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalReference.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports